import React from 'react';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";

const AmountControl = ({ quantity, onIncrement, onDecrement }) => (
    <MDBox sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: '#ebecee', borderRadius: 100, padding: 0.5}}>
        <IconButton onClick={onDecrement} sx={{backgroundColor: '#FFFFFF'}} size="small">
            <RemoveIcon />
        </IconButton>
        <MDTypography variant="body1" mx={1} sx={{fontSize: 12}}>{quantity}</MDTypography>
        <IconButton onClick={onIncrement} sx={{backgroundColor: '#FFFFFF'}} size="small">
            <AddIcon />
        </IconButton>
    </MDBox>
);

export default AmountControl;
